import { useState, useEffect } from 'react'

const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

export default function useCurrentWidth() {
    if (typeof window !== 'undefined') {
        // save current window width in the state object
        let [width, setWidth] = useState(getWidth())

        // in this case useEffect will execute only once because
        // it does not have any dependencies.
        useEffect(() => {
            // timeoutId for debounce mechanism
            let timeoutId = null
            const resizeListener = () => {
                // prevent execution of previous setTimeout
                clearTimeout(timeoutId)
                // change width from the state object after 150 milliseconds
                timeoutId = setTimeout(() => setWidth(getWidth()), 150)
            }
            // set resize listener
            window.addEventListener('resize', resizeListener)

            // clean up function
            return () => {
                // remove resize listener
                window.removeEventListener('resize', resizeListener)
            }
        }, [])
        return width
    } else {
        return 0
    }
}

const getHeight = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

export function useCurrentHeight() {
    if (typeof window !== 'undefined') {
        // save current window width in the state object
        let [height, setHeight] = useState(getHeight())

        // in this case useEffect will execute only once because
        // it does not have any dependencies.
        useEffect(() => {
            // timeoutId for debounce mechanism
            let timeoutId = null
            const resizeListener = () => {
                // prevent execution of previous setTimeout
                clearTimeout(timeoutId)
                // change Height from the state object after 150 milliseconds
                timeoutId = setTimeout(() => setHeight(getHeight()), 150)
            }
            // set resize listener
            window.addEventListener('resize', resizeListener)

            // clean up function
            return () => {
                // remove resize listener
                window.removeEventListener('resize', resizeListener)
            }
        }, [])
        return height
    } else {
        return 0
    }
}
